import React from 'react';
import { Container, Grid, Paper, Typography, Box } from '@mui/material';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import DescriptionIcon from '@mui/icons-material/Description';
// import ContactMailIcon from '@mui/icons-material/ContactMail';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';

/**
 * Dashboard / Home Page
 * Compact, professional dashboard with statistics cards
 */
const Dashboard = () => {
  const stats = [
    // { label: 'Total Orders', value: '25', icon: <ShoppingCartIcon />, color: 'primary.main' },
    // { label: 'Active Quotations', value: '20', icon: <DescriptionIcon />, color: 'secondary.main' },
    // { label: 'Pending Enquiries', value: '30', icon: <ContactMailIcon />, color: 'warning.main' },
    // { label: 'Conversion Rate', value: '68%', icon: <TrendingUpIcon />, color: 'success.main' }
  ];

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 1.5, sm: 2 }, px: { xs: 1, sm: 2 } }}>
      <Typography variant="h5" sx={{ mb: { xs: 2, sm: 2.5 }, fontSize: { xs: '1.125rem', sm: '1.25rem' }, fontWeight: 600 }}>
        Dashboard
      </Typography>

      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        {stats.map((stat) => (
          <Grid item xs={12} sm={6} md={3} key={stat.label}>
            <Paper
              sx={{
                p: { xs: 1.5, sm: 2 },
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                borderRadius: { xs: 1, sm: 2 },
                boxShadow: { xs: 1, sm: 2 },
                transition: 'all 0.2s ease',
                border: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                  transform: { xs: 'none', sm: 'translateY(-2px)' },
                  boxShadow: { xs: 1, sm: 4 },
                  borderColor: stat.color,
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: { xs: 1, sm: 1.5 } }}>
                <Box
                  sx={{
                    color: stat.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: { xs: 36, sm: 40 },
                    height: { xs: 36, sm: 40 },
                    borderRadius: { xs: 1, sm: 1.5 },
                    backgroundColor: `${stat.color}15`,
                  }}
                >
                  {React.cloneElement(stat.icon, { sx: { fontSize: { xs: '1.25rem', sm: '1.5rem' } } })}
                </Box>
              </Box>
              <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem' }, fontWeight: 700, mb: 0.5 }}>
                {stat.value}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.8125rem' } }}>
                {stat.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 3 }}>
        <Paper 
          sx={{ 
            p: 2.5, 
            borderRadius: 2,
            boxShadow: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6" sx={{ mb: 1.5, fontSize: '1rem', fontWeight: 600 }}>
            Welcome to VACSPL ENQUIRY Dashboard
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph sx={{ fontSize: '0.875rem', mb: 1.5 }}>
            This dashboard helps you manage leads, quotations, and orders efficiently.
            Use the navigation menu to access different sections:
          </Typography>
          <Box component="ul" sx={{ pl: 2.5, m: 0, '& li': { mb: 0.75, fontSize: '0.875rem' } }}>
            <li><strong>My Orders:</strong> View and manage all orders</li>
            <li><strong>My Quotations:</strong> Track quotation status and revisions</li>
            <li><strong>My Enquiry:</strong> Manage customer enquiries and leads</li>
            <li><strong>My Progress:</strong> View your performance metrics</li>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Dashboard;
